import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';

export class VendorModuleParamConfigModel {
  constructor(private moduleParamConfigGlob: ModuleParamGlobConfigService) {}

  paramData = {
    title: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'title', 'Business Partner'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'subtitle', 'Business Partner Registration'),
    },
    basicDetail: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'basicDetail', 'Basic Details'),
    },
    vendor_name: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'party_name', 'Partner Name'),
    },
    vendor_type: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'party_type', 'Business Partner Type'),
    },
    product_type: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'product_type', 'Product Category'),
    },
    vendor_type_category: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'party_type_category', 'Party Type Category'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'party_type_category'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'party_type_category'),
    },
    gst_number: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'gst_number', 'TAX Number'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'gst_number'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'gst_number'),
    },
    pan: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'pan', 'PAN'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'pan'),
    },
    country: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'country', 'Country'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'country'),
    },
    state: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'state', 'State'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'state'),
    },
    company_website: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'company_website', 'Company Website'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'company_website'),
    },
    transports: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'transports', 'Transporter Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'transports'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'transports'),
    },
    salesHead: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'salesHead', 'Sales Head'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'salesHead'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'salesHead'),
    },
    vendorCode: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'vendorCode', 'Business Partner Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'vendorCode'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'vendorCode'),
    },
    segment: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'segment', 'Segment'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'segment'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'segment'),
    },
    terms_of_payment: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'terms_of_payment', 'Terms Of Payment'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'terms_of_payment'),
    },
    billing_address: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'billing_address', 'Billing Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'billing_address'),
    },
    address: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'address', 'Address'),
    },
    streetAddress: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'streetAddress', 'Street Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'streetAddress'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'streetAddress'),
    },
    area: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'area', 'Area / City'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'area'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'area'),
    },
    pin: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'pin', 'Pin Code'),
      isRequired: this.moduleParamConfigGlob.isRequired('vendor', 'pin'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'pin'),
    },
    bankDetail: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'bankDetail', 'Bank Details'),
    },
    bank_name: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'bank_name', 'Bank Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'bank_name'),
    },
    ifsc_code: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'ifsc_code', 'IFSC Code'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'ifsc_code'),
    },
    holder_name: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'holder_name', 'Holder Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'holder_name'),
    },
    account_number: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'account_number', 'Account Number'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'account_number'),
    },
    shipping_address: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'shipping_address', 'Shipping Address'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'shipping_address'),
    },
    userName: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'userName', 'User Name'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'userName'),
    },
    password: {
      label: this.moduleParamConfigGlob.getLabel('vendor', 'password', 'Password'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendor', 'password'),
    },
  };
  contactDetailData = {
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'subtitle', 'Contact Details'),
    },
    first_name: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'first_name', 'First Name'),
    },
    last_name: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'last_name', 'Last Name'),
    },
    designation: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'designation', 'Designation'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendorContactDetails', 'designation'),
    },
    phone: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'phone', 'Phone'),
    },
    email: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'email', 'Email'),
    },
    secondary_phone: {
      label: this.moduleParamConfigGlob.getLabel('vendorContactDetails', 'secondary_phone', 'Secondary Phone'),
      isVisible: this.moduleParamConfigGlob.isVisible('vendorContactDetails', 'secondary_phone'),
    },
  };
  branchLocation = {
    default_Branch: {
      label: this.moduleParamConfigGlob.getLabel('VendorDetailsBranchModel', 'default_Branch', 'Default Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('VendorDetailsBranchModel', 'default_Branch'),
      isRequired: this.moduleParamConfigGlob.isRequired('VendorDetailsBranchModel', 'default_Branch'),
    },
    title: {
      label: this.moduleParamConfigGlob.getLabel('VendorDetailsBranchModel', 'title', 'Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('VendorDetailsBranchModel', 'title'),
      isRequired: this.moduleParamConfigGlob.isRequired('VendorDetailsBranchModel', 'title'),
    },
    addBranch: {
      label: this.moduleParamConfigGlob.getLabel('VendorDetailsBranchModel', 'addBranch', 'Add Branch'),
      isVisible: this.moduleParamConfigGlob.isVisible('VendorDetailsBranchModel', 'addBranch'),
      isRequired: this.moduleParamConfigGlob.isRequired('VendorDetailsBranchModel', 'addBranch'),
    },
    subtitle: {
      label: this.moduleParamConfigGlob.getLabel('VendorDetailsBranchModel', 'subtitle', 'Branch Details'),
      isVisible: this.moduleParamConfigGlob.isVisible('VendorDetailsBranchModel', 'subtitle'),
      isRequired: this.moduleParamConfigGlob.isRequired('VendorDetailsBranchModel', 'subtitle'),
    },
  };
}
